/*
 * Футер: секции "Customer Policies" и "Business Information"
 * на мобильном становятся сворачиваемыми (аккордеон), закрыты по умолчанию.
 * На десктопе — всегда раскрыты (управляется CSS-медиазапросом).
 */
(function () {
  var TITLES = /customer policies|business information/i;

  function findGroups() {
    var footer = document.querySelector('footer, [id*="footer"], .footer');
    if (!footer) return [];
    var heads = Array.prototype.slice
      .call(footer.querySelectorAll('h2, h3, h4'))
      .filter(function (h) { return TITLES.test(h.textContent); });
    return heads
      .map(function (h) { return { head: h, group: h.closest('.group-block-content') }; })
      .filter(function (x) { return x.group; });
  }

  function setup() {
    findGroups().forEach(function (item) {
      var group = item.group, head = item.head;
      if (group.dataset.bhFaccInit) return;
      group.dataset.bhFaccInit = '1';
      group.classList.add('bh-facc');

      var headBlock = Array.prototype.slice.call(group.children).find(function (c) {
        return c.contains(head);
      }) || head;
      headBlock.classList.add('bh-facc__head');

      Array.prototype.slice.call(group.children).forEach(function (c) {
        if (c !== headBlock) c.classList.add('bh-facc__body');
      });

      headBlock.addEventListener('click', function () {
        if (window.innerWidth < 750) group.classList.toggle('bh-facc--open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else { setup(); }
  document.addEventListener('shopify:section:load', setup);
})();
